import { render } from "./TestUCConfirmation.vue?vue&type=template&id=41f3ec4e"
import script from "./TestUCConfirmation.vue?vue&type=script&lang=js"
export * from "./TestUCConfirmation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__